import * as React from 'react';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextAreaFormGroup, MenuItemDto, DropDownFormGroup, RichTextFormGroup, TextFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationError, getValidationErrorsForCollection } from '../../infrastructure/ValidationResult';
import { Delopgave } from '../../models/Delopgave';
import { SectionGroupDynamic } from '../../uiComponents/layout/SectionGroupDynamic';
import { Section } from '../../uiComponents/layout/Section';
import { OpgaveBedoemmesAfEnum } from '../../models/enums/OpgaveBedoemmesAfEnum';
import { OpgavenBedoemmesEfterEnum } from '../../models/enums/OpgavenBedoemmesEfterEnum';
import { ResultatAngivesIEnum } from '../../models/enums/ResultatAngivesIEnum';
import MultipleChoiceSpoergsmaalComponent from './MultipleChoiceSpoergsmaalComponent';
import { EditorState } from 'draft-js';
import { AddContentButton } from '../../uiComponents/input/Buttons';
import BedoemmelsesFaktorComponent from './BedoemmelsesFaktorComponent';

export interface DelopgaveComponentProps {
    delopgave: Delopgave;
    index: number;
    removeDelopgave: (key: any) => void;
    onDelopgaveChanged: (fieldName: string, value: any, index: number) => void;
    onDelopgaveResultatEnumChanged: (fieldName: string, value: any, index: number) => void;
    errorMessages: ValidationError[];
    addSpoergsmaal: (delopgaveIndex: number) => void;
    onSpoergsmaalChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number) => void;
    removeSpoergsmaal: (index: number, delopgaveIndex: number) => void;
    addSvarmulighed: (delopgaveIndex: number, spoergsmaalIndex: number) => void;
    onSvarmulighedChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number, spoergsmaalIndex: number) => void;
    removeSvarmulighed: (index: number, delopgaveIndex: number, spoergsmaalIndex: number) => void;
    onEditorChange: (editorState: EditorState, index: number) => void;
    editorState: EditorState;
    addBedoemmelsesFaktor: (delopgaveIndex: number) => void;
    onBedoemmelsesFaktorChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number) => void;
    removeBedoemmelsesFaktor: (index: number, delopgaveIndex: number) => void;
}

class DelopgaveComponent extends React.Component<DelopgaveComponentProps, any> {
    constructor(props: DelopgaveComponentProps) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.getSpoergsmaal = this.getSpoergsmaal.bind(this);
        this.getKendtVaerdiInput = this.getKendtVaerdiInput.bind(this);
    }

    onChange(field: string, value: string) {
        this.props.onDelopgaveChanged(field, value, this.props.index);
    }
    getSpoergsmaal() {
        if (this.props.delopgave.resultatetAngivesI === ResultatAngivesIEnum.MultipleChoice) {
            if (this.props.delopgave.multipleChoiceSpoergsmaal !== undefined) {
                return this.props.delopgave.multipleChoiceSpoergsmaal.map((mcs, i) =>
                    (
                        <MultipleChoiceSpoergsmaalComponent
                            multipleChoiceSpoergsmaal={mcs}
                            key={i}
                            index={i}
                            delopgaveIndex={this.props.index}
                            errorMessages={this.props.errorMessages}
                            onSpoergsmaalChanged={this.props.onSpoergsmaalChanged}
                            removeSpoergsmaal={this.props.removeSpoergsmaal}
                            addSvarmulighed={this.props.addSvarmulighed}
                            onSvarmulighedChanged={this.props.onSvarmulighedChanged}
                            removeSvarmulighed={this.props.removeSvarmulighed}
                        />
                    ));
            }
        }

        return [];
    }

    getBedoemmelsesFaktorer() {
        /* tslint:disable */
        if (this.visBedoemmelsesFaktorMuligheder()) {
            if (this.props.delopgave.delopgaveBedoemmelsesFaktorer !== undefined) {
                return this.props.delopgave.delopgaveBedoemmelsesFaktorer.map((bf, i) => (
                    <BedoemmelsesFaktorComponent
                        bedommelsesFaktor={bf}
                        key={i}
                        index={i}
                        delopgaveIndex={this.props.index}
                        errorMessages={this.props.errorMessages}
                        onBedoemmelsesFaktorChanged={this.props.onBedoemmelsesFaktorChanged}
                        removeBedoemmelsesFaktor={this.props.removeBedoemmelsesFaktor}
                    />
                ));
            }
        }
        return [];
        /* tslint:enable */
    }

    getSpoergsmaalButton() {
        if (this.props.delopgave.resultatetAngivesI === ResultatAngivesIEnum.MultipleChoice) {
            return (
                <Section>
                    <Row>
                        <Col md={6} mdOffset={3}>
                            <AddContentButton text={'Tilføj spørgsmål'} buttonOnClick={() => this.props.addSpoergsmaal(this.props.index)} />
                        </Col>
                    </Row>
                </Section>
            );
        }

        return;
    }

    getBedoemmelsesFaktorButton() {
        /* tslint:disable */
        if (this.visBedoemmelsesFaktorMuligheder()) {
            return (
                <Section>
                    <Row>
                        <Col md={6} mdOffset={3}>
                            <AddContentButton text={'Tilføj bedømmelsesfaktor'} buttonOnClick={() => this.props.addBedoemmelsesFaktor(this.props.index)} />
                        </Col>
                    </Row>
                </Section>
            )
        }
        return;
        /* tslint:enable */
    }

    getSkalStartesManueltCheckbox() {
        if (this.props.delopgave.resultatetAngivesI === ResultatAngivesIEnum.MultipleChoice) {
            return (
                <Row>
                    <Col md={3} mdOffset={1}>
                        <input
                            type='checkbox'
                            id={'chkSkalStartesManuelt_' + this.props.index}
                            checked={this.props.delopgave.skalStartesManuelt}
                            onChange={(e) => this.onSkalStartesManueltChanged(e)}
                        />
                        <label htmlFor={'chkSkalStartesManuelt_' + this.props.index}>Skal startes manuelt</label>
                    </Col>
                </Row>
            );
        }

        return;
    }

    // delopgave.OpgavenbedoemmesEfter konverteres til en int ellers fejler sammenligningen med OpgavenBedoemmesEfterEnum 
    visBedoemmelsesFaktorMuligheder() { 
        const erOpgavebedommelseHoejereBedreEllerLavereBedre = (Number(this.props.delopgave.opgavenBedoemmesEfter) === OpgavenBedoemmesEfterEnum.HoejereErBedre ||            
        Number(this.props.delopgave.opgavenBedoemmesEfter) === OpgavenBedoemmesEfterEnum.LavereErBedre);

        const erResultatAngivesIHeltalEllerKommatal = (this.props.delopgave.resultatetAngivesI === ResultatAngivesIEnum.Heltal ||
            this.props.delopgave.resultatetAngivesI === ResultatAngivesIEnum.Kommatal);

        return erOpgavebedommelseHoejereBedreEllerLavereBedre && erResultatAngivesIHeltalEllerKommatal;
    }

    getKendtVaerdiInput() {
        const s: string = OpgavenBedoemmesEfterEnum[OpgavenBedoemmesEfterEnum.TaetPaaKendtVaerdi];
        const bedoemmesEfter: string = OpgavenBedoemmesEfterEnum[this.props.delopgave.opgavenBedoemmesEfter];
        if (bedoemmesEfter === s) {
            return (
                <Row>
                    <Col md={10} mdOffset={1}>
                        <TextFormGroup
                            errorMessages={this.props.errorMessages}
                            label='Kendt værdi*'
                            name='kendtVaerdi'
                            placeholder='Skriv kendt værdi'
                            value={this.props.delopgave.kendtVaerdi}
                            maxlength={15}
                            onChange={this.onChange}
                        />
                    </Col>
                </Row>
            );
        }
        return;
    }

    onSkalStartesManueltChanged = (e: any) => {
        this.onChange('skalStartesManuelt', e.target.checked);
    }

    render() {
        let delopgaveErrors = getValidationErrorsForCollection(this.props.errorMessages, 'delopgave', this.props.index);

        let bedoemmesAfItems: MenuItemDto[] = new Array();
        bedoemmesAfItems.push(new MenuItemDto(OpgaveBedoemmesAfEnum.Elever, 'Elever'));
        bedoemmesAfItems.push(new MenuItemDto(OpgaveBedoemmesAfEnum.EksterneLaerer, 'Eksterne/lærere'));
        bedoemmesAfItems.push(new MenuItemDto(OpgaveBedoemmesAfEnum.Piloter, 'Piloter'));

        let bedoemmesEfterItems: MenuItemDto[] = new Array();
        bedoemmesEfterItems.push(new MenuItemDto(OpgavenBedoemmesEfterEnum.HoejereErBedre, 'Højere er bedre'));
        bedoemmesEfterItems.push(new MenuItemDto(OpgavenBedoemmesEfterEnum.Valgmuligheder, 'Valgmuligheder'));

        let resultatetAngivesIItems: MenuItemDto[] = new Array();
        resultatetAngivesIItems.push(new MenuItemDto(ResultatAngivesIEnum.Heltal, 'Heltal'));
        resultatetAngivesIItems.push(new MenuItemDto(ResultatAngivesIEnum.Kommatal, 'Kommatal'));
        resultatetAngivesIItems.push(new MenuItemDto(ResultatAngivesIEnum.MultipleChoice, 'Multiple choice'));

        let titel = this.props.delopgave.titel;
        if (titel === undefined) {
            titel = '';
        }

        return (
            <SectionGroupDynamic className='delopgave-section-group' index={this.props.index} deleteOnClick={() => this.props.removeDelopgave(this.props.index)} header={titel}>
                <Section>
                    <Row>
                        <Col md={10} mdOffset={1}>
                            <TextFormGroup
                                errorMessages={this.props.errorMessages}
                                label='Titel*'
                                name='titel'
                                placeholder='Skriv titel'
                                value={this.props.delopgave.titel}
                                onChange={this.onChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10} mdOffset={1}>
                            <RichTextFormGroup
                                onEditorChange={(editorState: EditorState) => this.props.onEditorChange(editorState, this.props.index)}
                                editorState={this.props.editorState}
                            />
                        </Col>
                    </Row>
                </Section>
                <Section>
                    <Row>
                        <Col md={10} mdOffset={1}>
                            <Row>
                                <Col md={4}>
                                    <DropDownFormGroup
                                        errorMessages={this.props.errorMessages}
                                        items={bedoemmesAfItems}
                                        name='opgavenBedoemmesAf'
                                        label='Opgavesvar indtastes af*'
                                        selectedValue={this.props.delopgave.opgavenBedoemmesAf}
                                        onChange={(fieldName: string, value: any) => this.props.onDelopgaveChanged(fieldName, value, this.props.index)}
                                        ingenValgtText='Vælg bedømmes af...'
                                    />
                                </Col>
                                <Col md={4}>
                                    <DropDownFormGroup
                                        errorMessages={this.props.errorMessages}
                                        items={bedoemmesEfterItems}
                                        name='opgavenBedoemmesEfter'
                                        label='Opgaven bedømmes efter*'
                                        selectedValue={this.props.delopgave.opgavenBedoemmesEfter}
                                        onChange={(fieldName: string, value: any) => this.props.onDelopgaveChanged(fieldName, value, this.props.index)}
                                        ingenValgtText='Vælg opgaven bedømmes efter...'
                                    />
                                </Col>
                                <Col md={4}>
                                    <DropDownFormGroup
                                        errorMessages={this.props.errorMessages}
                                        items={resultatetAngivesIItems}
                                        name='resultatetAngivesI'
                                        label='Resultatet angives i*'
                                        selectedValue={this.props.delopgave.resultatetAngivesI}
                                        onChange={(fieldName: string, value: any) => this.props.onDelopgaveResultatEnumChanged(fieldName, value, this.props.index)}
                                        ingenValgtText='Vælg resultat angivelse...'
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {this.getKendtVaerdiInput()}
                    <Row>
                        <Col md={10} mdOffset={1}>
                            <TextAreaFormGroup
                                errorMessages={delopgaveErrors}
                                label='Evt. vejledning til bedømmelse'
                                name='bedoemmelsesvejledning'
                                placeholder='Skriv beskrivelse'
                                value={this.props.delopgave.bedoemmelsesvejledning}
                                onChange={this.onChange}
                            />
                        </Col>
                    </Row>
                    {this.getSkalStartesManueltCheckbox()}
                </Section>
                {this.getSpoergsmaal()}
                {this.getSpoergsmaalButton()}                
                {this.getBedoemmelsesFaktorer()}
                {this.getBedoemmelsesFaktorButton()}
            </SectionGroupDynamic>
        );
    }
}

export default DelopgaveComponent;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/DelopgaveComponent.tsx